/**
 * App-level Supabase client — reads Vite env vars and passes to factory.
 *
 * This is the ONLY place in this app where env vars are read for Supabase.
 * All other modules import `supabase` from this file.
 */
import { createBrowserClient } from '@pazportal/supabase';

export const supabase = createBrowserClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
);
